import { useSelector } from 'react-redux';

export const CourseBreadcrumb = (id) => {
  const coursesById = useSelector((state) => state.courseSlice.coursesById);
  return coursesById?.[id]?.title;
};

export const ModuleBreadcrumb = (id) => {
  const modulesById = useSelector((state) => state.courseSlice.modulesById);
  return modulesById?.[id]?.title;
};
